import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataFieldService } from 'app/shared/services/data-field.service';
import { SubjectLinkService } from 'app/shared/services/subject-link.service';
import { SubjectService } from 'app/shared/services/subject.service';
import { value } from 'devexpress-dashboard/model/index.metadata';

@Component({
  selector: 'app-task-notification-dialog',
  templateUrl: './task-notification-dialog.component.html',
  styleUrls: ['./task-notification-dialog.component.scss'],
})
export class TaskNotificationDialogComponent implements OnInit {
  form: UntypedFormGroup;
  peopleSubjects: any[];
  //peopleSubjectsNames: any[];
  personsArray: any[];

  constructor(
    public dialogRef: MatDialogRef<TaskNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
    private datafieldService: DataFieldService,
    private linkedSubjectService: SubjectLinkService
  ) {
    const newData = data.filter(
      (people) => people.linkedSubject.subjectType.name == 'Person'
    );
    const datafields = newData.map(
      (person) => person.linkedSubject.subjectType.dataFields
    );
    const id = datafields[0].filter((datafield) => datafield.label == 'Email');
    this.peopleSubjects = newData.filter(
      (people) => people.linkedSubject.subjectData.data[id[0].id]
    );
    //this.peopleSubjects = [...data.sort((a,b) => a.summary.localeCompare(b.summary))];
  }

  ngOnInit(): void {
    this.personsArray = this.peopleSubjects.map((person) => {
      const control = new UntypedFormControl({
        value: true,
      });
      control.setValue(person.receiveTaskNotification);
      return control;
    });

    // const persons = this.formBuilder.array([]);
    // this.peopleSubjects.forEach((person) => {
    //   persons.push(
    //     this.formBuilder.control({ value: person.receiveTaskNotification })
    //   );
    // });
    this.form = this.formBuilder.group({
      items: new UntypedFormArray(this.personsArray),
    });
  }

  changeReceiveTaskNotification(event, subject) {
    const id = this.peopleSubjects.findIndex(
      (person) => person.id == subject.id
    );
    this.peopleSubjects[id].receiveTaskNotification = event.checked;
    console.log(this.peopleSubjects);
  }

  public confirmSubmit() {
    this.dialogRef.close({
      subjects: this.peopleSubjects,
    });
  }
}
